
export const _meses = [
    { value : 1, label : 'enero', label_mini : 'ene' },
    { value : 2, label : 'febrero', label_mini : 'feb' },
    { value : 3, label : 'marzo', label_mini : 'mar' },
    { value : 4, label : 'abril', label_mini : 'abr' },
    { value : 5, label : 'mayo', label_mini : 'may' },
    { value : 6, label : 'junio', label_mini : 'jun' },
    { value : 7, label : 'julio', label_mini : 'jul' },
    { value : 8, label : 'agosto', label_mini : 'ago' },
    { value : 9, label : 'septiembre', label_mini : 'sep' },
    { value : 10, label : 'octubre', label_mini : 'oct' },
    { value : 11, label : 'noviembre', label_mini : 'nov' },
    { value : 12, label : 'diciembre', label_mini : 'dic' },
]

export const _dias = [
    { value : 1, frm_label: 'lunes', label : 'lunes', label_mini : 'lun' },
    { value : 2, frm_label: 'martes', label : 'martes', label_mini : 'mar' },
    { value : 3, frm_label: 'miercoles', label : 'miércoles', label_mini : 'mier' },
    { value : 4, frm_label: 'jueves', label : 'jueves', label_mini : 'juev' },
    { value : 5, frm_label: 'viernes', label : 'viernes', label_mini : 'vier' },
    { value : 6, frm_label: 'sabado', label : 'sábado', label_mini : 'sab' },
    { value : 0, frm_label: 'domingo', label : 'domingo', label_mini : 'dom' },
]

export const _horas = [
    "00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00",
    "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00",
    "16:00", "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00", "24:00"
]

export const _pedidosEstatus = [
    { value: 'RECIBIDO', label : 'Recibido' },
    { value: 'PENDIENTE', label : 'Pendiente' },
    { value: 'CANCELADO', label : 'Cancelado' },
    { value: 'RECEPCION PARCIAL', label : 'Recepción Parcial' },
    { value: 'FINALIZADO POR USUARIO', label : 'Finalizado por Usuario' },
]

export const _traspasosEstatus = [
    { value: 'RECIBIDO', label : 'Recibido' },
    { value: 'PENDIENTE', label : 'Pendiente' },
    { value: 'DESPACHADO', label : 'Despachado' },
    { value: 'POR_RECIBIR', label : 'Por Recibir' },
    { value: 'CANCELADO', label : 'Cancelado' },
]

export const _tiposPromociones = [
    { value: 'COMBO', label : 'Combo' },
    { value: 'MXN', label : 'MXN' },
    { value: 'HAPPY_HOUR', label : 'Happy Hour' },
    { value: 'SELECCION_N', label : 'Selección N' },
]

export const _clasificaciones = [
    { value: 'ESTRELLA', label: 'Estrella', icon: 'tabler:star-filled', color: 'success' },
    { value: 'ROMPECABEZAS', label: 'Rompecabezas', icon: 'tabler:puzzle-filled', color: 'info' },
    { value: 'CABALLO', label: 'Caballo', icon: 'tabler:horse', color: 'warning' },
    { value: 'PERRO', label: 'Perro', icon: 'tabler:dog', color: 'error' },
]

export const _tiposCuentas = [
    'Tarjeta', 'Clabe', 'CIE', 'Cuenta'
]

export const _tiposAbonos = [
    'cfdi','sms','whats'
]

export const _roles = {
    admin : 1,
    cliente : 2,
}

export const _sistemasEquipos = [
    'Linux', 'Windows', 'Android', 'IOS'
]

export const _tiposDispositvos = [
    { id : 1, 'desc' : 'Servidor' },
    { id : 2, 'desc' : 'Caja' },
    { id : 3, 'desc' : 'Terminal Mesero' },
    { id : 4, 'desc' : 'Tablet Mesero' },
    { id : 5, 'desc' : 'Monitor Comandas' },
    { id : 6, 'desc' : 'Impresora' },
    { id : 7, 'desc' : 'Router' },
]

export const _tiposMovimientosCuentas = [
    { value: 'EGRESO', label: 'Egreso' },
    { value: 'INGRESO', label: 'Ingreso' },
]

export const _origenesMermas = [
    'AJUSTE_INVENTARIO',
    'CADUCIDAD',
    'DEVOLUCION',
    'MANUAL'
]

export const _tiposActualizadoresPrecios = [
    'PLATILLOS', 'MODIFICADORES'
]

export const _themeDefaults = {
    themeMode: 'dark',
    themeDirection: 'ltr',
    themeContrast: 'bold',
    themeLayout: 'vertical',
    themeColorPresets: 'red',
    themeStretch: false,
}

export const _sessionDefaults = {
    auth : {
        token : null,
        expiration : null
    },
    user : null
}

export const _hookDataDefault = {
    loaded : false,
    list : []
}

export const _clientesDefaults = {
    loaded : false,
    list : []
}

export const _sucursalesDefaults = {
    loaded : false,
    list : []
}

export const _distribuidoresDefaults = {
    loaded : false,
    list : []
}
export const _regimenesSatDefault = {
    loaded : false,
    list : []
}
export const _planesDefault = {
    loaded : false,
    list : []
}
export const _plantillasDefault = {
    loaded : false,
    list : []
}
export const _confactosDefault = {
    loaded : false,
    list : []
}

export const _menuDefault = {
    loaded : false,
    data : null
}

export const _cptosSatCobranza = [
    { value : '81111811', label : 'Servicios de soporte técnico o de mesa de ayuda' },
    { value : '81112209', label : 'Mantenimiento de software de desarrollo' },
    { value : '81112221', label : 'Servicio de mantenimiento del software del punto de venta' },
]

export const _estatusCfdi = [
    { value: 'EMITIDO', label : 'Emitido' },
    { value: 'CANC_PEND', label : 'Canc. pendiente' },
    { value: 'CANCELADO', label : 'Cancelado' },
]

export const _estatusCfdiRecibidos = [
    { value: 'VIGENTE', label : 'Vigente' },
    { value: 'CANCELADO', label : 'Cancelado' },
    { value: 'PENDIENTE', label : 'Pendiente' },
    { value: 'NO ENCONTRADO', label : 'No encontrado' }
]

export const _formasPago = [
    { value : '01', label : 'Efectivo', label_min : 'Efectivo' },
    { value : '02', label : 'Cheque Nominativo', label_min : 'Cheque' },
    { value : '03', label : 'Transferencia electrónica de fondos', label_min : 'Transferencia' },
    { value : '04', label : 'Tarjeta de crédito', label_min : 'Tarjeta de crédito' },
    { value : '05', label : 'Monedero electrónico', label_min : 'Monedero electrónico' },
    { value : '06', label : 'Dinero electrónico', label_min : 'Dinero electrónico' },
    { value : '08', label : 'Vales de despensa', label_min : 'Vales de despensa' },
    { value : '12', label : 'Dación de pago', label_min : 'Dación de pago' },
    { value : '13', label : 'Pago por subrogración', label_min : 'Pago por subrogración' },
    { value : '14', label : 'Pago por consignación', label_min : 'Pago por consignación' },
    { value : '15', label : 'Condonación', label_min : 'Condonación' },
    { value : '17', label : 'Compensación', label_min : 'Compensación' },
    { value : '23', label : 'Novación', label_min : 'Novación' },
    { value : '24', label : 'Confusión', label_min : 'Confusión' },
    { value : '25', label : 'Remisión de deuda', label_min : 'Remisión de deuda' },
    { value : '26', label : 'Prescipción o caducidad', label_min : 'Prescipción o caducidad' },
    { value : '27', label : 'A satisfacción del acreedor', label_min : 'A satisfacción del acreedor' },
    { value : '28', label : 'Tarjeta de débito', label_min : 'Tarjeta de débito' },
    { value : '29', label : 'Tarjeta de servicios', label_min : 'Tarjeta de servicios' },
    { value : '30', label : 'Aplicación de anticipos', label_min : 'Aplicación de anticipos' },
    { value : '99', label : 'Por definir', label_min : 'Por definir' },
    { value : '31', label : 'Intermediario pagos', label_min : 'Intermediario pagos' },
]

export const _tiposServicios = [
    { id: 1, desc: 'PARA LLEVAR', codigo : 'LL' },
    { id: 2, desc: 'SERVICIO RESTAURANTE', codigo : 'SR' },
    { id: 3, desc: 'SERVICIO DOMICILIO', codigo : 'SD' },
]

export const acceptImagesFiles = {
    'image/png': [],
    'image/jpeg': []
}

export const acceptExcelFiles = {
    'application/vnd.ms-excel': [],
    'application/wps-office.xlsx': [],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [],
}